export default __webpack_public_path__ + "static/SRF Carabrew 6S6902 - Fiche de spécifications et données techniques-196875aba0b198e4fa1dfa2c685d306a.pdf";